import PointsDisplay from './PointsDisplay';

export default PointsDisplay;
